/*
	Generated on 10/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import RequireAuth from '@/commons/auth/RequireAuth'

import DaftarPenggunaanRuanganPage from './containers/DaftarPenggunaanRuanganPage'

const penggunaanRuanganRoutes = [
{ 
	path: "/penggunaan-ruangan",
	element: <DaftarPenggunaanRuanganPage />,
}

	

]

export default penggunaanRuanganRoutes
